import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=29266c00"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=29266c00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports